import {inject} from '@angular/core';
import {CanActivateFn, Router, UrlTree} from '@angular/router';
import {AuthService} from "../service/auth.service";
import {Observable, switchMap, take, tap} from "rxjs";
import {filter} from "rxjs/operators";

const isAuthenticated = (): | boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);
  return authService.loading.pipe(
    filter(val => val === false),
    switchMap(auth => authService.isAuthenticated.pipe(
      take(1),
      tap((isAuthenticated: boolean) => {
        if (!isAuthenticated) {
          router.navigate(['/login']);
        }
        if (!authService.isPowerUser()) {
          router.navigate(['/']);
        }
      })
    ))
  );
}

export const AuthGuardPowerUser: CanActivateFn = isAuthenticated;
